import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sharelink',
  templateUrl: './sharelink.component.html',
  styleUrls: ['./sharelink.component.scss']
})
export class SharelinkComponent implements OnInit {
  data: any;
  url : string ='';
  text : string = '';
  landingUrl:string = environment.landingUrl;
  constructor(public dialog: MatDialogRef<SharelinkComponent>) { }

  ngOnInit() {
    let postId=this.data['postId'];
    let loanId=this.data['loanId'];
    let leadIds = this.data['leadIds'];
    // console.log(leadIds);
    if(loanId){
       this.url = `https://bancreach.page.link/?apn=com.bancReach&ibi=com.bancreach.banc&isi=1493006990&link=${this.landingUrl}/banker?loanId=${loanId}`;
       this.text = "You've just received a lead on BANCreach!";
    }
    if(postId){
       this.url = `https://bancreach.page.link/?apn=com.bancReach&ibi=com.bancreach.banc&isi=1493006990&link=${this.landingUrl}/banker?postId=${postId}`;
       this.text = "You've just received a post on BANCreach!";
    }
    if(leadIds){
      this.url = `https://bancreach.page.link/?apn=com.bancReach&ibi=com.bancreach.banc&isi=1493006990&link=${this.landingUrl}/banker?postId=${leadIds}`;
      this.text = "You've just received a post on BANCreach!";
    }
  }

  close(){
    this.dialog.close();
  }

}
